// extracted by extract-css-chunks-webpack-plugin
module.exports = {"selected-icon-wrapper":"QRMf-","color-pill":"L3uJC","pill-label":"xFl8n","facet-image":"MBOoX"};